import Scroll from "./modules/Scroll";
import Widget from "./modules/Widget";

Widget.addEventListeners();
document.querySelectorAll(Widget.selector()).forEach(el => {
	new Widget(el).initialize();
});

window.onload = () => {
	let widget = new Widget(document.querySelector(Widget.selector()));

	try {
		if (_config.onLoad.setKind ?? null) {
			widget.setKind(_config.onLoad.setKind);
		}
	} catch (error) {}

	try {
		if ((_config.onLoad.setKind ?? null) && (_config.onLoad.setAmount ?? null)) {
			widget.setAmount(_config.onLoad.setKind, _config.onLoad.setAmount);
		}
	} catch (error) {}

	try {
		if (_config.onLoad.setFormattedDonation ?? null) {
			widget.setFormattedDonation(_config.onLoad.setFormattedDonation);
		}
	} catch (error) {}

	try {
		if (_config.onLoad.setSlide ?? null) {
			widget.setSlide(_config.onLoad.setSlide);
		}
	} catch (error) {}

	try {
		if (_config.onLoad.scrollToWidget ?? null) {
			widget.scrollToTop();
		}
	} catch (error) {}

	try {
		if (_config.onLoad.sendToAnalytics ?? null) {
			widget.sendToAnalytics();
		}
	} catch (error) {}

	widget.refreshState();
}

Scroll.addEventListeners();

window.addEventListener("resize", () => {
	const widget = new Widget(document.querySelector(`.widget`));
	widget.sendDimensionMessage();
});

window.addEventListener("message", (event) => {
	try {
		if ((event?.data?.action ?? null == "addCSS") && (event?.data?.data?.url ?? null)) {
			const link = document.createElement("link");
			link.rel = "stylesheet";
			link.href = event.data.data.url ?? null;
			document.head.appendChild(link);
		}
	} catch (error) {
		console.log(error);
	}
});

/******************************************************************************
 * Analytics.
 */
document.addEventListener("click", event => {
	if (event.target.matches(".ga-event")) {
		ga("send", "event", event.target.dataset.gaEventCategory, event.target.dataset.gaEventAction, event.target.dataset.gaEventLabel, event.target.dataset.gaEventValue);
	}
});
